import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';


export default function UsersOverview() {
	return (
		<Flex direction='column' pt={{ sm: '125px', lg: '75px' }}>
			<Card px='0px'>
				Manage users placeholder
			</Card>
		</Flex>
	);
}
